import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { certificationsRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type CerificationsProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: {
      image: WPImage
      paragraph: string
    }[]
  }>

const Cerifications = ({ items, ...props }: CerificationsProps) => {
  return (
    <Motion animation={certificationsRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-gutter">
              {items?.map((item, index) => (
                <div
                  className={cn([
                    'col-span-2',
                    'md:col-span-3',
                    'lg:col-span-4',
                    'flex items-center gap-spacing-sm lg:gap-gutter',
                    { 'lg:col-start-5': index === 0 }
                  ])}
                  key={index}
                  data-motion-card
                >
                  {item.image?.url ? (
                    <div className="size-[8rem] shrink-0 lg:size-[12rem]">
                      <Media image={item.image} />
                    </div>
                  ) : null}
                  {item.paragraph ? (
                    <Typography variant="small">{item.paragraph}</Typography>
                  ) : null}
                </div>
              ))}
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default Cerifications
